/*
 * Copyright (c) 2021 EGT Digital - All rights reserved.
 *
 * File: dynamicMostPlayedGames.ts
 *
 * Written by Sterios Taskudis <sterios.taskudis@egt-digital.com> on  26.10.23 2:37 pm.
 * Last modified: 26.10.23 2:37 pm.
 *
 * More information at: https://egt-digital.com/
 */
import { getDynamicMostPlayedGamesUrl } from '../config';
import store from '../eventStore';
import IMostPlayedGame from '../interfaces/IDynamicMostPlayedGames';

export const getDynamicMostPlayedGames = async (): Promise<IMostPlayedGame[]> => {
    const currentSettings = store.SETTINGS.value;
    const url = getDynamicMostPlayedGamesUrl(currentSettings.apiHost);
    // helper code for dev testing only
    // return [
    //     {gameKey: 'MSHCSlot', orderNumber: 1},
    //     {gameKey: 'BCSlot', orderNumber: 2},
    //     {gameKey: 'EPSlot', orderNumber: 3},
    //     {gameKey: 'EDSlot', orderNumber: 4},
    //     {gameKey: 'TNBCSlot', orderNumber: 5},
    //     {gameKey: 'DWSlot', orderNumber: 6},
    // ]
    try {
        const data: IMostPlayedGame[] = await fetch(url).then(res => res.json());
        return data;
    } catch (e) {
        return [] as IMostPlayedGame[];
    }
};
